import { render, staticRenderFns } from "./MeshEditDialog.vue?vue&type=template&id=34b3cd5e"
import script from "./MeshEditDialog.vue?vue&type=script&lang=ts"
export * from "./MeshEditDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports